/* eslint-disable no-debugger */
import { Fragment } from 'react';
import useSelectionsAdminTool from './UseSelectionsAdminTool';
import SelectionsAdminToolGrid from './SelectionsAdminToolGrid';
// import SelectionsConferenceChampionshipMeetsDropdown from '../../../components/dropdowns/SelectionsConferenceChampionshipMeetsDropdown';
import SelectionsD1ConferencesDropdown from '../../../components/dropdowns/SelectionsD1ConferencesDropdown';

import Headings from '@usas/ui-web/components/headings/Headings';
import ReportPeriodDropdown from '@usas/ui-web/components/dropdowns/reportPeriodDropdown/ReportPeriodDropdown';
import global from '@usas/ui-web/components/GlobalStyle.module.css';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';
import ActionIntraPageButton from '@usas/ui-web/components/buttons/ActionIntraPageButton';
import ViewReport from '@usas/ui-web/components/embeddedReports/ViewReport';

const SelectionsAdminTool = () => {
  const {
    selectionsConferenceChampsState,
    filterState,
    formState,
    errorState,
    viewState,
    setViewState,
    onValueTextPairChanged,
    onSubmitChampionsFormGrid,
    onFilterClicked,
    onClearStatusClicked,
    onProcessConferenceChampsClicked,
    onRunReportClicked,
    NCAA_ORGANIZATION_ID,
    INITIAL_VIEW_STATE
  } = useSelectionsAdminTool();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>NCAA Conference Champions for Selections</Headings.H3>
        </div>
      </div>
      <form>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <hr />
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-sm-12 col-md-6">
            <ActionIntraPageButton onClick={(e) => onProcessConferenceChampsClicked(e)}>
              Process Conference Champions 
            </ActionIntraPageButton>
            {/* <br /> */}
            {/* <span style={{fontSize: 20}} className={global.UsasTextGray}>Reloads the grid data and clears any existing confirmations.</span> */}
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6">
            <ActionIntraPageButton onClick={(e) => onRunReportClicked(e)}>
              Run Report 
            </ActionIntraPageButton>
          </div>
        </div>
        <div className="row usas-extra-top-margin">
          <div className="col-xs-12 col-sm-12 col-md-6">
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-5">
            <ReportPeriodDropdown
              label="Registration Year"
              name="reportPeriodId"
              value={formState.reportPeriodId}
              error={errorState.reportPeriodId}
              message={errorState.reportPeriodId}
              onChange={(newValue, newValueLabel) =>
                onValueTextPairChanged(newValue, 'reportPeriodId', newValueLabel, 'reportPeriodName')}
              organizationId={NCAA_ORGANIZATION_ID}
              defaultOption={true}
              currentAndFutureOptionsOnly={false} />
          </div>
          <div className="col-xs-12 col-sm-12 col-md-5">
            <SelectionsD1ConferencesDropdown
              label="D1 Conference"
              name="hostOrgUnitId"
              value={formState.hostOrgUnitId}
              error={errorState.hostOrgUnitId}
              message={errorState.hostOrgUnitId}
              onChange={(newValue, newValueLabel) =>
                onValueTextPairChanged(newValue, 'hostOrgUnitId', newValueLabel, 'orgUnitName')} />
          </div>
          <div className='col-xs-6 col-sm-12 col-md-2'>
            <button className={global.PlainButton} onClick={(e) => onFilterClicked(e)}>Filter</button>
          </div>
        </div>
      </form>
      <div className="row usas-extra-top-margin">
        <div className="col-xs-12">
          <SelectionsAdminToolGrid
            data={filterState.filteredData}
            isLoading={filterState.isFiltering}
            onSubmitFormCallback={onSubmitChampionsFormGrid}
            onClearStatusClicked={onClearStatusClicked}
          />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={filterState.isFiltering || selectionsConferenceChampsState.isArrayLoading} />
      {viewState.showReport === true &&
        <div className="row">
          <div className="col-xs-12 usas-extra-top-margin">
            <ViewReport
              reportInfoId={viewState.reportInfoId}
              reportParameters={viewState.reportParameters}
              onBackToGrid={() => setViewState({ ...INITIAL_VIEW_STATE })}
            />
          </div>
        </div>
      }
      
    </Fragment>
  );
}

export default SelectionsAdminTool;